import React from 'react';
import ReactDOM from 'react-dom';
import 'mapbox-gl/dist/mapbox-gl.css';
import './index.css';
import App from './App';
import { createTheme, ThemeProvider } from '@mui/material/styles';
import { accent } from './utils/colorDict';

// Publish the collection's accent colour to CSS. index.css styles a few things
// React never touches (scrollbar thumbs, swiper arrows); without this they stay
// Scholten blue on every deployment.
document.documentElement.style.setProperty('--maqom-accent', accent);

// MUI components with no explicit colour fall back to its default blue
// (#1976d2) — that is why the "updating" LinearProgress under the header, and
// assorted buttons and switches, looked unrelated to the site's palette on
// every deployment. Setting `primary` once keeps them in the collection's hue.
const theme = createTheme({
  palette: { primary: { main: accent } },
});

ReactDOM.render(
  <ThemeProvider theme={theme}>
    <App />
  </ThemeProvider>,
  document.getElementById('root')
);
